import { render, staticRenderFns } from "./AddTeamToCompany.vue?vue&type=template&id=19369084"
import script from "./AddTeamToCompany.vue?vue&type=script&lang=ts"
export * from "./AddTeamToCompany.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports